var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_271_2476)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_271_2476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7002 23.15C1.7002 21.1618 3.31197 19.55 5.3002 19.55H34.1002C36.0884 19.55 37.7002 21.1618 37.7002 23.15V47.1501C37.7002 49.1383 36.0884 50.75 34.1002 50.75H5.30019C3.31197 50.75 1.7002 49.1383 1.7002 47.15V23.15Z",
    fill: "#43CDEC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.7002 23.15C1.7002 21.1618 3.31197 19.55 5.3002 19.55H34.1002C36.0884 19.55 37.7002 21.1618 37.7002 23.15V47.1501C37.7002 49.1383 36.0884 50.75 34.1002 50.75H5.30019C3.31197 50.75 1.7002 49.1383 1.7002 47.15V23.15Z",
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_271_2476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7002 23.15C16.7002 21.1618 18.312 19.55 20.3002 19.55H46.7002C48.6884 19.55 50.3002 21.1618 50.3002 23.15V47.1501C50.3002 49.1383 48.6884 50.75 46.7002 50.75H20.3002C18.312 50.75 16.7002 49.1383 16.7002 47.15V23.15Z",
    fill: "#43CDEC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.7002 23.15C16.7002 21.1618 18.312 19.55 20.3002 19.55H46.7002C48.6884 19.55 50.3002 21.1618 50.3002 23.15V47.1501C50.3002 49.1383 48.6884 50.75 46.7002 50.75H20.3002C18.312 50.75 16.7002 49.1383 16.7002 47.15V23.15Z",
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9 20.15H41.6L33.2 50.15H27.5L35.9 20.15Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.65 20.15H34.55L26.15 50.15H25.25L33.65 20.15Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_271_2476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.7002,
    y: 27.35,
    width: 16.95,
    height: 0.9,
    rx: 0.45,
    fill: "#292D32",
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2871 29.8783C33.2871 34.7582 31.2771 37.2307 27.3034 37.2307C22.0603 37.2307 20.1891 33.7164 20.1891 30.4214C20.1891 29.5989 19.965 29.4892 19.6629 29.3561C19.2351 29.1655 19.2022 27.9279 19.244 27.3198C19.2487 27.2518 19.3019 27.1969 19.3692 27.1861C25.0263 26.2819 27.8476 26.2137 31.5143 26.9655C32.4019 27.1475 32.8157 27.6692 33.038 28.4046H36.5206C36.7477 27.6692 37.1703 27.1475 38.0769 26.9655C41.8223 26.2136 44.7041 26.2819 50.4835 27.1865C50.5509 27.197 50.6042 27.2519 50.609 27.3199C50.6517 27.9281 50.6181 29.1655 50.1813 29.3561C49.8727 29.4892 49.6438 29.5989 49.6438 30.4214C49.6438 33.7164 47.7327 37.2307 42.3777 37.2307C38.3191 37.2307 36.2662 34.7582 36.2662 29.8783C36.293 29.6195 36.3218 29.3713 36.3588 29.1363H33.1965C33.2327 29.3713 33.2609 29.6195 33.2871 29.8783Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2871 29.8783H34.3371V29.8253L34.3318 29.7726L33.2871 29.8783ZM19.6629 29.3561L19.2356 30.3152L19.2394 30.3169L19.6629 29.3561ZM19.244 27.3198L20.2916 27.3918V27.3918L19.244 27.3198ZM19.3692 27.1861L19.5349 28.2229H19.5349L19.3692 27.1861ZM31.5143 26.9655L31.3034 27.9941V27.9941L31.5143 26.9655ZM33.038 28.4046L32.033 28.7085L32.2586 29.4546H33.038V28.4046ZM36.5206 28.4046V29.4546H37.2953L37.5239 28.7144L36.5206 28.4046ZM38.0769 26.9655L38.2835 27.995V27.995L38.0769 26.9655ZM50.4835 27.1865L50.3211 28.2238L50.3211 28.2238L50.4835 27.1865ZM50.609 27.3199L49.5616 27.3935V27.3935L50.609 27.3199ZM50.1813 29.3561L50.5973 30.3202L50.6011 30.3185L50.1813 29.3561ZM36.2662 29.8783L35.2218 29.7703L35.2162 29.8242V29.8783H36.2662ZM36.3588 29.1363L37.396 29.2995L37.5869 28.0863H36.3588V29.1363ZM33.1965 29.1363V28.0863H31.9724L32.1587 29.2962L33.1965 29.1363ZM27.3034 38.2807C29.5197 38.2807 31.3524 37.5804 32.5999 36.0471C33.8144 34.5544 34.3371 32.4364 34.3371 29.8783H32.2371C32.2371 32.2001 31.7549 33.7582 30.9709 34.7218C30.2199 35.6448 29.0608 36.1807 27.3034 36.1807V38.2807ZM19.1391 30.4214C19.1391 32.2522 19.6577 34.2225 20.9881 35.751C22.3417 37.3063 24.4289 38.2807 27.3034 38.2807V36.1807C24.9348 36.1807 23.4648 35.398 22.5721 34.3723C21.6561 33.3199 21.2391 31.8855 21.2391 30.4214H19.1391ZM19.2394 30.3169C19.2776 30.3337 19.2946 30.3416 19.3063 30.3474C19.3162 30.3522 19.3096 30.3496 19.2947 30.3397C19.2785 30.3291 19.2538 30.3109 19.2264 30.284C19.1985 30.2565 19.1741 30.2263 19.1544 30.1954C19.1149 30.1336 19.113 30.099 19.12 30.1336C19.1276 30.1716 19.1391 30.2586 19.1391 30.4214H21.2391C21.2391 29.9532 21.1832 29.4706 20.9242 29.0651C20.6407 28.6211 20.2236 28.4558 20.0863 28.3953L19.2394 30.3169ZM18.1965 27.2477C18.1722 27.6008 18.1682 28.1377 18.2372 28.638C18.2713 28.8849 18.3297 29.1741 18.4398 29.4421C18.5364 29.6771 18.7557 30.1014 19.2356 30.3152L20.0902 28.397C20.3561 28.5155 20.4109 28.7136 20.3823 28.644C20.3672 28.6073 20.3399 28.5134 20.3175 28.351C20.2736 28.0328 20.274 27.6469 20.2916 27.3918L18.1965 27.2477ZM19.2034 26.1493C18.6833 26.2324 18.2368 26.6626 18.1965 27.2477L20.2916 27.3918C20.2607 27.841 19.9205 28.1613 19.5349 28.2229L19.2034 26.1493ZM31.7252 25.9369C27.8836 25.1492 24.9212 25.2354 19.2034 26.1493L19.5349 28.2229C25.1313 27.3284 27.8116 27.2781 31.3034 27.9941L31.7252 25.9369ZM34.0431 28.1008C33.9009 27.6303 33.6727 27.1445 33.2725 26.7395C32.8631 26.3251 32.3406 26.0631 31.7252 25.9369L31.3034 27.9941C31.5757 28.05 31.7039 28.1398 31.7788 28.2156C31.863 28.3008 31.9529 28.4436 32.033 28.7085L34.0431 28.1008ZM33.038 29.4546H36.5206V27.3546H33.038V29.4546ZM37.5239 28.7144C37.6049 28.4519 37.6959 28.3096 37.783 28.2234C37.8618 28.1454 37.9979 28.0524 38.2835 27.995L37.8702 25.9361C37.2493 26.0607 36.7208 26.3196 36.3049 26.7317C35.8972 27.1356 35.6634 27.6219 35.5174 28.0948L37.5239 28.7144ZM38.2835 27.995C41.8575 27.2775 44.6012 27.3286 50.3211 28.2238L50.6458 26.1491C44.8071 25.2352 41.7871 25.1497 37.8702 25.9361L38.2835 27.995ZM50.3211 28.2238C49.9352 28.1634 49.5932 27.8437 49.5616 27.3935L51.6564 27.2464C51.6153 26.66 51.1665 26.2306 50.6458 26.1491L50.3211 28.2238ZM49.5616 27.3935C49.5794 27.6476 49.5798 28.0318 49.5353 28.3481C49.5125 28.5094 49.4849 28.6017 49.4702 28.6368C49.4429 28.7019 49.4991 28.5081 49.7614 28.3937L50.6011 30.3185C51.0819 30.1088 51.3061 29.6888 51.4066 29.4494C51.5197 29.1798 51.5798 28.889 51.6147 28.6411C51.6855 28.139 51.6813 27.6004 51.6564 27.2464L49.5616 27.3935ZM49.7652 28.392C49.6273 28.4515 49.2057 28.6145 48.9174 29.0566C48.6514 29.4644 48.5938 29.951 48.5938 30.4214H50.6938C50.6938 30.2596 50.7055 30.1741 50.7129 30.1378C50.7196 30.1053 50.717 30.1415 50.6762 30.2039C50.656 30.235 50.6312 30.2649 50.6034 30.2917C50.5761 30.3179 50.5518 30.3354 50.5365 30.3453C50.5224 30.3544 50.5167 30.3565 50.5276 30.3512C50.5402 30.3451 50.5583 30.337 50.5973 30.3201L49.7652 28.392ZM48.5938 30.4214C48.5938 31.8801 48.1698 33.3114 47.2341 34.3641C46.3197 35.3928 44.8096 36.1807 42.3777 36.1807V38.2807C45.3008 38.2807 47.4238 37.3115 48.8036 35.7593C50.1622 34.231 50.6938 32.2576 50.6938 30.4214H48.5938ZM42.3777 36.1807C40.5704 36.1807 39.3774 35.6398 38.6076 34.7134C37.8074 33.7505 37.3162 32.1959 37.3162 29.8783H35.2162C35.2162 32.4405 35.7514 34.5621 36.9924 36.0555C38.2637 37.5854 40.1264 38.2807 42.3777 38.2807V36.1807ZM37.3107 29.9862C37.3367 29.734 37.3633 29.5072 37.396 29.2995L35.3215 28.9731C35.2803 29.2353 35.2492 29.5049 35.2218 29.7703L37.3107 29.9862ZM36.3588 28.0863H33.1965V30.1863H36.3588V28.0863ZM34.3318 29.7726C34.305 29.5073 34.2746 29.2381 34.2343 28.9765L32.1587 29.2962C32.1908 29.5044 32.2169 29.7316 32.2425 29.984L34.3318 29.7726Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0996,
    cy: 31.4,
    r: 2.25,
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.7998,
    cy: 31.4,
    r: 2.25,
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3747 31.175C20.3746 29.825 20.0747 26.825 22.6997 26.825",
    stroke: "#292D32",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4749 31.175C49.475 29.825 49.7749 26.825 47.1499 26.825",
    stroke: "#292D32",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7.99961,
    cy: 37.25,
    r: 5.4,
    fill: "#1F2024",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_271_2476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.84922,
    cy: 35.6,
    r: 5.4,
    fill: "#4399FF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7.84922,
    cy: 35.6,
    r: 5.4,
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34961 32C9.89566 32.2907 10.3625 32.7611 10.6996 33.35",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_271_2476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.85,
    cy: 35.6,
    r: 3.6,
    fill: "#4399FF"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4.85,
    cy: 35.6,
    r: 3.6,
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 41L34 43",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_271_2476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.09961,
    y: 12.9,
    width: 34.95,
    height: 6.15,
    rx: 0.3,
    fill: "#4399FF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 8.09961,
    y: 12.9,
    width: 34.95,
    height: 6.15,
    rx: 0.3,
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_271_2476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.8496,
    y: 7.94995,
    width: 27.45,
    height: 4.95,
    rx: 0.3,
    fill: "#4399FF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.8496,
    y: 7.94995,
    width: 27.45,
    height: 4.95,
    rx: 0.3,
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_271_2476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5498,
    y: 4.05005,
    width: 22.05,
    height: 3.9,
    rx: 0.3,
    fill: "#4399FF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.5498,
    y: 4.05005,
    width: 22.05,
    height: 3.9,
    rx: 0.3,
    stroke: "#292D32",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii_271_2476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.4502,
    y: 0.449951,
    width: 14.25,
    height: 3.6,
    rx: 0.3,
    fill: "#4399FF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.4502,
    y: 0.449951,
    width: 14.25,
    height: 3.6,
    rx: 0.3,
    stroke: "#292D32",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_271_2476",
    x: 1.10059,
    y: 18.9501,
    width: 37.1992,
    height: 32.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_271_2476"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_271_2476",
    result: "effect2_innerShadow_271_2476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_271_2476",
    x: 16.1006,
    y: 18.9501,
    width: 34.7998,
    height: 32.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -24,
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_271_2476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_271_2476",
    x: 0.499609,
    y: 25.4001,
    width: 51.1732,
    height: 13.4806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.6,
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_271_2476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_271_2476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_271_2476",
    x: 1.84961,
    y: 29.6,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_271_2476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_271_2476",
    x: 0.650391,
    y: 31.4,
    width: 8.39941,
    height: 8.40002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_271_2476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_271_2476",
    x: 7.5,
    y: 12.3,
    width: 36.1494,
    height: 7.34998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_271_2476"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_271_2476",
    result: "effect2_innerShadow_271_2476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_271_2476",
    x: 11.25,
    y: 7.34998,
    width: 28.6494,
    height: 6.15002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_271_2476"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_271_2476",
    result: "effect2_innerShadow_271_2476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_271_2476",
    x: 13.9502,
    y: 3.45007,
    width: 23.25,
    height: 5.09998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_271_2476"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_271_2476",
    result: "effect2_innerShadow_271_2476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_271_2476",
    x: 17.8506,
    y: -0.150024,
    width: 15.4492,
    height: 4.79993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_271_2476"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_271_2476",
    result: "effect2_innerShadow_271_2476"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_271_2476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoAlert);
export default __webpack_public_path__ + "static/media/info_alert.70cfe6f2a915566d81010f72cd3463ea.svg";
export { ForwardRef as ReactComponent };